import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext"; // ✅ Context Import
import logo from "../assets/images/win11-logo.webp";

function Navbar() {
  const navigate = useNavigate();
  const { user, loading } = useContext(UserContext);

  // Derive Data Safe Check
  const wallet = user?.wallet || { deposited: 0, winnings: 0, bonus: 0 };
  const totalBalance = (wallet.deposited || 0) + (wallet.winnings || 0) + (wallet.bonus || 0);
  
  // Notification Count (Abhi 0 hai, baad me API se connect kar lena)
  const notificationCount = 0; 

  // 🔥 PROFILE WALA EXACT KYC VERIFIED LOGIC
  const isKycVerified = user?.kyc?.pan?.status === 'VERIFIED';

  return (
    // ✨ Glassmorphism Effect added to Navbar
    <nav className="navbar fixed-top transition-all shadow" 
         style={{
             height: '70px', 
             background: 'rgba(255, 255, 255, 1)', 
            //  backdropFilter: 'blur(10px)',
             borderBottom: '1px solid rgb(255, 255, 255)',
             zIndex: 1000
         }}>
      
      <div className="container-fluid px-3 d-flex justify-content-between align-items-center">

        {/* === LOGO SECTION === */}
        <div className="d-flex align-items-center gap-2" role="button" onClick={() => navigate("/home")}>
          <img 
            src={logo} 
            alt="win11-logo" 
            className="img-fluid" 
            style={{ width: "40px", height: "40px", filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.1))" }} 
          />
        </div>

        {/* === RIGHT SIDE ACTION AREA === */}
        <div className="d-flex align-items-center gap-3">
          
          {user ? (
            loading ? (
                // 💀 SHIMMER LOADING
                <div className="d-flex align-items-center gap-3 placeholder-glow">
                    <span className="placeholder rounded-pill bg-secondary opacity-10" style={{width: '80px', height: '35px'}}></span>
                    <span className="placeholder rounded-circle bg-secondary opacity-10" style={{width: '35px', height: '35px'}}></span>
                </div>
            ) : (
                <>
                  {/* 💰 WALLET PILL (Premium Look) */}
                  <div 
                    className="d-flex align-items-center bg-white border border-secondary-subtle rounded-pill px-3 py-1 shadow-sm cursor-pointer hover-scale"
                    onClick={() => navigate("/wallet")}
                    style={{ transition: '0.2s', cursor: 'pointer' }}
                  >
                    <i className="bi bi-wallet2 text-primary fs-5 me-2"></i>
                    <span className="fw-bold text-dark" style={{fontSize: '0.95rem'}}>
                        ₹{totalBalance.toLocaleString()}
                    </span>
                  </div>

                  {/* 🔔 NOTIFICATION */}
                  <button
                    className="btn btn-light rounded-circle position-relative border-0 d-flex align-items-center justify-content-center hover-bg"
                    style={{width: '40px', height: '40px', background: '#f3f4f6'}}
                    onClick={() => navigate("/notifications")}
                  >
                    <i className="bi bi-bell-fill text-dark fs-5"></i>
                    {notificationCount > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle">
                            <span className="visually-hidden">New alerts</span>
                        </span>
                    )}
                  </button>

                  {/* 👤 USER AVATAR WITH VERIFIED TICK */}
                  <div 
                    className="position-relative cursor-pointer hover-scale"
                    onClick={() => navigate("/profile")}
                    style={{ transition: "0.2s" }}
                  >
                    <img 
                        src={user.avatar || "https://cdn-icons-png.flaticon.com/512/149/149071.png"} 
                        alt="Profile"
                        className="rounded-circle border border-2 border-white shadow-sm"
                        style={{width: '40px', height: '40px', objectFit: 'cover'}}
                        onError={(e) => { e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png" }}
                    />
                    
                    {/* 🔥 NEW: BLUE TICK OVERLAY (Profile status ke hisab se) */}
                    {isKycVerified && (
                        <i 
                            className="bi bi-patch-check-fill position-absolute"
                            style={{
                                bottom: "-2px", 
                                right: "-4px", 
                                color: "#1d9bf0", // Twitter jaisa premium blue
                                fontSize: "16px",
                                background: "white", // Border ke peechhe ka gap cover karne ke liye
                                borderRadius: "50%",
                                lineHeight: "1",
                                padding: "0px",
                                border: "1.5px solid white",
                                zIndex: 10
                            }}
                            title="KYC Verified User"
                        ></i>
                    )}
                  </div>
                </>
            )
          ) : (
            <button 
                className="btn btn-dark btn-sm rounded-pill px-4 py-2 fw-bold shadow-sm hover-scale" 
                onClick={() => navigate("/auth")}
            >
                Login
            </button>
          )}
        </div>
      </div>

      <style>{`
        .hover-scale:hover { transform: scale(1.05); }
        .hover-bg:hover { background-color: #e5e7eb !important; }
        .cursor-pointer { cursor: pointer; }
      `}</style>
    </nav>
  );
}

export default Navbar;